import request from '@/utils/request'

let Ma_supervisorApi = {

  /*监督员列表*/
  list(data) {
    return request._post('/shop/plus.ma_supervisor.Index/index', data);
},
/*添加监督员*/
add(data) {
    return request._post('/shop/plus.ma_supervisor.Index/add', data);
},
/*修改监督员*/
edit(data) {
    return request._post('/shop/plus.ma_supervisor.Index/edit', data);
},
/*删除监督员*/
del(data) {
    return request._post('/shop/plus.ma_supervisor.Index/del', data);
},
/*监督员详情*/
detail(data) {
  return request._post('/shop/plus.ma_supervisor.Index/detail', data);
},

/*重置密码*/
resetPassword(data) {
  return request._post('/shop/plus.ma_supervisor.Index/resetPassword', data);
},
/*离职*/
resign(data) {
  return request._post('/shop/plus.ma_supervisor.Index/resign', data);
},
/*获取任职记录*/
getEmploymentRecords(data) {
  return request._post('/shop/plus.ma_supervisor.Index/getEmploymentRecords', data);
},
/*获取计划记录*/
getPlanRecords(data) {
  return request._post('/shop/plus.ma_supervisor.Index/getPlanRecords', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ma_supervisor.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ma_supervisor.Setting/getSetting', data, errorback);
    },
}
export default Ma_supervisorApi;



// WEBPACK FOOTER //
// ./src/api/ma_supervisor.js